exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".debug-store-scan-button-container{position:fixed;bottom:8px;left:8px;z-index:1;padding:8px;background:#fff;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,.15)}body.has-bottom-nav .debug-store-scan-button-container{bottom:calc(var(--bottom-nav-height, 4.5em) + 8px)}", ""]);

// exports
